<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <span>{{ 'SUAS.ACCOUNT.DETAILS.GLOBAL_SEARCH_SETTINGS' | translate }}</span>
    <span class="ui-icon-close c-p" matDialogClose></span>
  </div>
  <div [formGroup]="settingsForm" class="body gap-16">
    <div class="flex-row gap-8">
      <ui-toggle formControlName="markResult"></ui-toggle>
      {{ 'GLOBAL_SEARCH_SETTINGS.MARK_RESULT' | translate }}
    </div>
    <div class="flex-row gap-8">
      <ui-toggle formControlName="includeAllMatch"></ui-toggle>
      {{ 'GLOBAL_SEARCH_SETTINGS.INCLUDE_ALL_MATCH' | translate }}
    </div>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      (clickAction)="save()"
      [text]="'SUAS.COMMON.SAVE' | translate"
    ></ui-button>
  </div>
</div>
